import Icon from '@components/common/assets';
import { ProfileInfoType } from '@components/match/profile/types';
import { MatchingApplyResultsVO } from '@domain/vo/match/MatchingProfileVO';
import { ApplyType } from '@domain/rs/match/MatchingProfileRs';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './skillReport.module.scss';
const cx = classnames.bind(styles);

const NotCompleted = ({ title, onClick }: { title: string; onClick: () => void }) => {
  return (
    <a role="button" className={cx('container')} onClick={onClick}>
      <div className={cx('titleContainer')}>
        <div className={cx('title')}>{title}</div>
        <div className={cx('description')}>
          결과표를 선택해 주세요.
          <Icon name="arrowRightLight" width={24} height={24} />
        </div>
      </div>
      <Icon name="errorLight" width={32} height={32} fill={Colors.C_ERROR} />
    </a>
  );
};

const Completed = ({
  applyEndDateTime,
  title,
  onClick,
}: {
  applyEndDateTime: string;
  title: string;
  onClick: () => void;
}) => {
  return (
    <a role="button" className={cx('container')} onClick={onClick}>
      <div className={cx('titleContainer')}>
        <div className={cx('title')}>{title}</div>
        <div className={cx('createdAtContainer')}>
          <div className={cx('createdAt')}>
            <span className={cx('dateText')}>응시완료</span>
            {applyEndDateTime}
          </div>
          <Icon name="arrowRightLight" width={24} height={24} />
        </div>
      </div>
      <a className={cx('checkLight')}>
        <Icon name="checkCircleLight" width={32} height={32} fill={Colors.C_GREEN_100} />
      </a>
    </a>
  );
};

interface ISkillReportProps {
  profileInfoType: ProfileInfoType;
  applyResults?: MatchingApplyResultsVO[];
  onClick: (applyType: ApplyType) => void;
}

const SkillReport = ({ profileInfoType, applyResults, onClick }: ISkillReportProps) => {
  const isGeneral = profileInfoType === 'GENERAL';

  if (isGeneral) {
    const result = applyResults?.find((result) => result.applyType === 'ACC');
    return <Report result={result} applyType="ACC" onClick={() => onClick('ACC')} />;
  }

  const PACCResult = applyResults?.find((result) => result.applyType === 'PACC');
  const PSTResult = applyResults?.find((result) => result.applyType === 'PST');
  return (
    <>
      <Report result={PACCResult} applyType="PACC" onClick={() => onClick('PACC')} />
      <Report result={PSTResult} applyType="PST" onClick={() => onClick('PST')} />
    </>
  );
};

export default SkillReport;

const Report = ({
  result,
  applyType,
  onClick,
}: {
  result?: MatchingApplyResultsVO;
  applyType: ApplyType;
  onClick: () => void;
}) => {
  return (
    <>
      {result ? (
        <Completed
          applyEndDateTime={result.applyEndDateTime}
          title={getTitleText(result.applyType)}
          onClick={onClick}
        />
      ) : (
        <NotCompleted title={getTitleText(applyType)} onClick={onClick} />
      )}
    </>
  );
};

const getTitleText = (applyType: ApplyType) => {
  switch (applyType) {
    case 'ACC':
      return '역량검사 결과표';
    case 'PACC':
      return '개발자 역량검사 결과표';
    case 'PST':
      return '개발구현능력 검사 결과표';
    default:
      return '';
  }
};
